import { jsx as _jsx } from "react/jsx-runtime";
import { useStateForPath } from "@react-navigation/core";
import { createContext, useRef } from "react";
import { getRouteInfo } from "./getRouteInfo";
var RouteInfoContext = /* @__PURE__ */ createContext(void 0);
function RouteInfoContextProvider(param) {
  var { children } = param;
  var currentState = useStateForPath();
  var currentStateRef = useRef(void 0);
  var lastStateRef = useRef(void 0);
  var cachedRouteInfoValueRef = useRef(void 0);
  var lazilyCalculatedRouteInfo = useRef(void 0);
  if (currentState && currentStateRef.current !== currentState) {
    lazilyCalculatedRouteInfo.current = makeLazilyCalculatedRouteInfo({
      currentStateRef,
      lastStateRef,
      cachedRouteInfoValueRef
    });
  }
  currentStateRef.current = currentState;
  return /* @__PURE__ */ _jsx(RouteInfoContext.Provider, {
    value: currentState ? lazilyCalculatedRouteInfo.current : void 0,
    children
  });
}
function makeLazilyCalculatedRouteInfo(param) {
  var { currentStateRef, lastStateRef, cachedRouteInfoValueRef } = param;
  return new Proxy({}, {
    get(_, p) {
      var state = currentStateRef.current;
      if (!state) {
        throw new Error("[lazilyCalculatedRouteInfo] cannot get state");
      }
      if (!cachedRouteInfoValueRef.current || lastStateRef.current !== state) {
        cachedRouteInfoValueRef.current = getRouteInfo(state);
        lastStateRef.current = state;
      }
      return cachedRouteInfoValueRef.current[p];
    }
  });
}
export {
  RouteInfoContext,
  RouteInfoContextProvider
};
//# sourceMappingURL=RouteInfoContext.js.map
